import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseComponent } from '@ids-components';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import '@github/markdown-toolbar-element';

@Component({
  selector: 'app-assessment-preview-info',
  templateUrl: './assessment-preview-info.component.html',
  styleUrls: ['./assessment-preview-info.component.scss'],
  imports: [CommonModule, DividerModule, ButtonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AssessmentPreviewInfoComponent extends BaseComponent implements OnInit {
  assessment: any = null;

  constructor(
    public dialogRef: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
  ) {
    super();
  }

  async ngOnInit() {
    await this.prepareConfigs();
    const assessment = this.dialogConfig?.data?.assessment;
    this.assessment = {
      ...(assessment || {}),
      descriptionPreview: this.sanitizer.bypassSecurityTrustHtml(this.util.parseMarkdown(assessment?.description || '')),
      assessmentType: {
        ...(assessment?.assessment_type || {}),
        descriptionPreview: this.sanitizer.bypassSecurityTrustHtml(this.util.parseMarkdown(assessment?.assessment_type?.description || '')),
      },
    };
  }
}
